<template>
  <div>
    <v-breadcrumbs :items="breadcrumbs_items" large></v-breadcrumbs>
    <v-container>
      <h1 class="headline font-weight-light mb-2">
        Заявление №{{ application.id }}
      </h1>

      <v-card outlined class="mb-5">
        <v-card-title>
          <div class="text-body-1 font-weight-regular">
            <div v-if="application.is_close && !application.is_reject">
              <p class="red--text">Заявление отклонено</p>
              <div class="text--secondary text-body-2">
                <p class="mb-2">Ваше заявление отклонено или удалено!</p>
                <p class="mb-2">Если вы считаете это ошибкой, свяжитесь с приемной комиссией КузГТУ!</p>
              </div>
            </div>
            <div v-else-if="application.is_done">
              <p class="green--text">Заявление принято</p>
              <div class="text--secondary text-body-2">
                <p class="mb-2">{{ abiturient.first_name }}, поздравляем вас, ваше заявление на поступление в КузГТУ
                  принято!</p>
              </div>
            </div>
            <div v-else-if="application.is_reject && application.is_work && !application.is_close">
              <p class="indigo--text">Ожидает проверки</p>
              <div class="text--secondary text-body-2">
                <p class="mb-0">Заявление отправлено оператору на повторную проверку.</p>
              </div>
            </div>
            <div v-else-if="application.is_reject && !application.is_work && !application.is_close">
              <p class="orange--text">Требуется доработка заявления</p>
              <div class="text--secondary text-body-2">
                <p>Оператор проверил заявление, но на данный момент не может его принять.</p>
                <p>Пожалуйста, устраните неточности, которые указаны в сообщении:</p>
                <v-alert class="text--secondary" border="left" dense tile>{{ application.messege_reject }}</v-alert>
              </div>
            </div>
            <div v-else-if="application.is_work || (application.is_reject && application.is_close)">
              <p class="indigo--text">На проверке</p>
              <div class="text--secondary text-body-2">
                <p class="mb-2">Оператор увидел ваше заявление и приступил к проверке.</p>
              </div>
            </div>
            <div v-else>
              <p class="blue--text">Ожидает проверки</p>
              <div class="text--secondary text-body-2">
                <p class="mb-0">Заявление зарегистрировано системой и ожидает проверки оператором.</p>
              </div>
            </div>
          </div>
        </v-card-title>
      </v-card>


      <v-card outlined class="mb-5">
        <v-card-text>
          <p class="mb-2" v-if="application.campaign">
            Образовательная организация: {{ application.campaign.name }}
          </p>
          <p class="mb-2" v-if="application.application_type">
            Уровень образования: {{ application.application_type.education_level_name }}
          </p>
          <p class="mb-2" v-if="application.application_type">
            Форма обучения: {{ application.application_type.form_name }}
          </p>
          <p class="mb-0" v-if="application.completed_datetime">
            Дата подачи заявления: {{ application.completed_datetime }}
          </p>
        </v-card-text>

        <v-card-text v-if="applicationFiles.length > 0">
          <p class="mb-0">Прикрепленные вами документы и заполненные бланки по текущему заявлению:</p>
          <v-list dense max-width="280px">
            <v-list-item
              link
              v-for="(item, index) in applicationFiles"
              :key="index"
              :href="'/files/' + item.name"
              target="_blank"
            >
              <v-list-item-avatar class="hidden-md-and-down">
                <v-icon v-if="item.filetype === 'pdf'">{{ icons.mdiFilePdfOutline }}</v-icon>
                <v-icon v-else>{{ icons.mdiFileImageOutline }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="`Заявление #` + parseInt(index + 1)"></v-list-item-title>
                <v-list-item-subtitle class="text-caption font-weight-regular">Размер: {{ item.size }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>

      </v-card>

<!--      <v-card outlined class="mb-5" v-if="exam && exam[0]">-->
<!--        <v-card-title class="text-body-1 font-weight-regular">-->
<!--          Дистанционная сдача экзаменов через личный кабинет-->
<!--        </v-card-title>-->
<!--        <v-card-text>-->
<!--          <ol>-->
<!--            <li>-->
<!--              Пройдите по ссылке:-->
<!--              <a class="font-weight-regular indigo&#45;&#45;text"-->
<!--                 v-bind:href="exam[0].protector.url"-->
<!--                 target="_blank"-->
<!--                 v-text="exam[0].protector.url"-->
<!--              ></a>-->
<!--            </li>-->
<!--          </ol>-->
<!--          <ol start="2">-->
<!--            <li>Скачайте ваш персональный экзаменационный билет.</li>-->
<!--          </ol>-->

<!--          <v-list dense max-width="280px" v-if="exam[0].visible">-->
<!--            <v-list-item-->
<!--              link-->
<!--              v-for="(item, index) in examFiles"-->
<!--              :key="index"-->
<!--              :href="'/files/' + item.name"-->
<!--              target="_blank"-->
<!--            >-->
<!--              <v-list-item-avatar class="hidden-md-and-down">-->
<!--                <v-icon v-if="item.filetype === 'pdf'">{{ icons.mdiFilePdfOutline }}</v-icon>-->
<!--                <v-icon v-else>{{ icons.mdiFileImageOutline }}</v-icon>-->
<!--              </v-list-item-avatar>-->
<!--              <v-list-item-content>-->
<!--                <v-list-item-title v-text="`Экзаменационный билет`"></v-list-item-title>-->
<!--                <v-list-item-subtitle class="text-caption font-weight-regular">Размер: {{ item.size }}-->
<!--                </v-list-item-subtitle>-->
<!--              </v-list-item-content>-->
<!--            </v-list-item>-->
<!--          </v-list>-->
<!--          <p class="ml-6" v-else>Билет будет доступен для скачивания после вашей верификации (подтверждения-->
<!--            личности).</p>-->

<!--          <ol start="3">-->
<!--            <li>-->
<!--              После решения билета, создайте его-->
<!--              <v-tooltip bottom max-width="600">-->
<!--                <template v-slot:activator="{ on, attrs }">-->
<!--                  <span class="text&#45;&#45;secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>-->
<!--                </template>-->
<!--                Фотография с телефона или скан-копия документа.-->
<!--                Качество изображений должно обеспечивать читаемость информации.-->
<!--                Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.-->
<!--              </v-tooltip>-->
<!--              и прикрепите в поле "Выбрать файл".-->
<!--            </li>-->
<!--          </ol>-->
<!--          <file-input-->
<!--            :type="parseInt(exam[0].exam)+3"-->
<!--            :application="application"-->
<!--            :max-files="10"-->
<!--          ></file-input>-->

<!--          <small>-->
<!--            После прикрепления билета, статус вашего заявления должен измениться на-->
<!--            &laquo;Ожидает проверки&raquo;, это означает, что заявление повторно отправлено на проверку-->
<!--            оператору.-->
<!--          </small>-->
<!--        </v-card-text>-->
<!--      </v-card>-->

      <v-card outlined class="mb-5" v-if="contractFiles && contractFiles.length">
        <v-card-title class="text-body-1 font-weight-regular">
          Сформированный договор об оказании платных образовательных услуг
        </v-card-title>
        <v-card-text>
          <ol>
            <li>Скачайте, внимательно ознакомьтесь, распечатайте и подпишите договор.</li>
          </ol>
          <v-list dense max-width="300px" class="">
            <v-list-item
              link
              v-for="(item, index) in contractFiles"
              :key="index"
              :href="'/files/' + item.name"
              target="_blank"
            >
              <v-list-item-avatar class="hidden-md-and-down">
                <v-icon class="green--text" v-if="item.filetype === 'pdf'">{{ icons.mdiFilePdfOutline }}</v-icon>
                <v-icon class="green--text" v-else>{{ icons.mdiFileImageOutline }}</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title v-text="item.chip_name"></v-list-item-title>
                <v-list-item-subtitle class="text-caption font-weight-regular">Размер: {{ item.size }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <ol start="2">
            <li>
              Создайте
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                </template>
                Фотография с телефона или скан-копия документа.
                Качество изображений должно обеспечивать читаемость информации.
                Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
              </v-tooltip>
              подписанного договора и прикрепите в поле "Выбрать файл".
            </li>
          </ol>
          <file-input
            ref="type104Files"
            :type="104"
            :application="application"
            :max-files="20"
          ></file-input>
          <ol start="3">
            <li class="mb-2">
              <a class="font-weight-regular indigo--text"
                 v-bind:href="getContractAgeementFile()"
                 target="_blank"
              >Скачайте</a>
              и распечатайте бланк согласия на зачисление на места с оплатой стоимости обучения.
            </li>
            <li class="mb-2">
              Создайте
              <v-tooltip bottom max-width="600">
                <template v-slot:activator="{ on, attrs }">
                  <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
                </template>
                Фотография с телефона или скан-копия документа.
                Качество изображений должно обеспечивать читаемость информации.
                Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
              </v-tooltip>
              согласия и прикрепите в поле "Выбрать файл".
            </li>
          </ol>
          <file-input
            ref="type105Files"
            :type="105"
            :application="application"
            :max-files="1"
          ></file-input>
          <small>
            После прикрепления первого документа, статус вашего заявления должен измениться на
            &laquo;Ожидает проверки&raquo;, это означает, что заявление повторно отправлено на проверку
            оператору.<br>
            После этого вы также сможете прикреплять необходимые документы.
          </small>
        </v-card-text>
      </v-card>

      <v-card outlined class="mb-5">
        <v-card-title class="text-body-1 font-weight-regular">
          Отправка дополнительных (исправленных) документов и перечень бланков
        </v-card-title>
        <v-card-text class="pb-0">
          <p>Если вам необходимо изменить текущее заявление, создайте
            <v-tooltip bottom max-width="600">
              <template v-slot:activator="{ on, attrs }">
                <span class="text--secondary" v-bind="attrs" style="border-bottom: 1px dashed" v-on="on">электронную копию</span>
              </template>
              Фотография с телефона или скан-копия документа.
              Качество изображений должно обеспечивать читаемость информации.
              Допустимые форматы: .png, .jpg, .jpeg или .pdf, максимальный размер на один файл: 20МБ.
            </v-tooltip>
            необходимых документов и прикрепите в поле "Выбрать файл".
          </p>
          <p class="mb-0">Бланки КузГТУ:</p>

          <ul class="py-2">
            <li>
              <a class="font-weight-regular indigo--text"
                 v-bind:href="'/files/personal/Согласие_на_обработку_и_распространение_ПДн_несовершеннолетнего_поступающего_в_КузГТУ.pdf'"
                 target="_blank"
              >бланк согласия на обработку и распространение ПДн НЕсовершеннолетнего поступающего</a>
            </li>
            <li>
              <a class="font-weight-regular indigo--text"
                 v-bind:href="'/files/personal/Согласие_на_обработку_и_распространение_ПДн_совершеннолетнего_поступающего_в_КузГТУ.pdf'"
                 target="_blank"
              >бланк согласия на обработку и распространение ПДн совершеннолетнего поступающего</a>
            </li>
<!--            <li>-->
<!--              <a class="font-weight-regular indigo&#45;&#45;text"-->
<!--                 v-bind:href="getFile('kcp')"-->
<!--                 target="_blank"-->
<!--              >контрольные цифры приема (КЦП)</a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="font-weight-regular indigo&#45;&#45;text"-->
<!--                 v-bind:href="getFile('application')"-->
<!--                 target="_blank"-->
<!--              >бланк заявления</a>-->
<!--              ( <a class="font-weight-regular indigo&#45;&#45;text"-->
<!--                   v-bind:href="getFile('application_example')"-->
<!--                   target="_blank"-->
<!--            >образец</a> )-->
<!--            </li>-->
            <li v-if="application.application_type && [1].includes(application.application_type.id)">
              <a class="font-weight-regular indigo--text"
                 v-bind:href="getFile('priority')"
                 target="_blank"
              >бланк приоритетности образовательных программ</a>
              ( <a class="font-weight-regular indigo--text"
                   v-bind:href="getFile('priority_example')"
                   target="_blank"
            >образец</a> )
            </li>
            <li>
              <a class="font-weight-regular indigo--text"
                 v-bind:href="getCancelFiles()"
                 target="_blank"
              >бланк отзыва поданных документов</a>
            </li>
          </ul>
          <small>
            Убедительная просьба сопоставить тип вашего заявления с текстом в бланках,
            возоможны ошибки с нашей стороны.
            По возможности, сообщите пожалуйста о неточностях в приемную комиссию.
          </small>
        </v-card-text>

        <v-card-text v-if="(application.is_reject || application.is_done) && !application.is_close">
          <file-input
            ref="type99Files"
            multiple
            :type="99"
            :application="application"
            :max-files="15"
          ></file-input>
          <small>
            После прикрепления первого документа, статус вашего заявления должен измениться на
            &laquo;Ожидает проверки&raquo;, это означает, что заявление вновь отправлено на проверку
            оператору.<br>
            После этого вы также сможете прикреплять необходимые документы.
          </small>
        </v-card-text>

      </v-card>

      <v-card outlined class="mb-8">
        <v-card-text>
          <small>
            Если у вас возникли вопросы или трудности свяжитесь с приемной комиссией КузГТУ по телефону:
            <a class="font-weight-regular indigo--text"
               v-bind:href="'tel:+73842682424'">+7 (3842) 68-24-24</a>.<br>
            Сообщите оператору номер текущего заявления: №{{ application.id }}
          </small>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
  mdiFileImageOutline,
  mdiFilePdfOutline,
} from "@mdi/js";
import {urls} from "@/_services/blank_file"

const FileInput = () => import('@/components/profile/FileInput')

export default {
  name: "Detail",
  components: {FileInput},
  props: ["id"],
  data() {
    return {
      icons: {
        mdiFileImageOutline,
        mdiFilePdfOutline,
      },
      breadcrumbs_items: [
        {text: 'Личный кабинет', disabled: false, to: {name: 'profile_application_list'}},
        {text: 'Просмотр заявления', disabled: true},
      ],
    }
  },
  async beforeRouteEnter(to, from, next) {
    await next(vm => vm.initData())
  },
  computed: {
    ...mapGetters("application", ["application"]),
    ...mapGetters("abiturient", ["abiturient"]),
    ...mapGetters("application_files", ["contractFiles"]),
    ...mapGetters("application_files", ["applicationFiles"]),
    ...mapGetters("application_files", ["examFiles"]),
    ...mapGetters("application_exams", ["exam"]),
  },
  methods: {
    async initData() {
      await Promise.all([
        await this.$store.dispatch("application/retrieveApplication", this.id)
          .then(() => {
            this.$store.dispatch("filemanager/loadUploadedFilesByApplication", this.application.id)
            this.$store.dispatch("application_files/loadFilesByApplication", this.application.id)
            this.$store.dispatch("application_files/loadContractFilesByApplication", this.application.id)
            this.$store.dispatch("application_files/loadExamFilesByApplication", this.application.id)
            this.$store.dispatch("application_exams/loadExams", this.application.id)
          })
          .catch(() => {
            this.$router.push({name: 'profile_application_list'})
          }),
      ])

      if (this.application.campaign && this.application.application_type) {
        if (this.application.campaign.id in urls && this.application.application_type.id in urls[this.application.campaign.id]) {
          this.documents = urls[this.application.campaign.id][this.application.application_type.id]
        }
      }
    },
    getFile(name) {
      if (this.documents && name in this.documents) {
        return this.documents[name]
      }
      return ''
    },
    getContractAgeementFile() {
      if ([1, 2, 8].includes(this.application.application_type.id)) {
        return '/files/app/БС/Согласие_на_зачисление_по_контракту.pdf';
      } else if ([3, 4, 7].includes(this.application.application_type.id)) {
        return '/files/app/МАГ/Согласие_на_зачисление_по_контракту.pdf';
      } else if ([5, 6].includes(this.application.application_type.id)) {
        return '/files/app/АСП/Согласие_на_зачисление_по_контракту.pdf';
      } else if ([9].includes(this.application.application_type.id)) {
        return '/files/app/СПО/Согласие_на_зачисление_по_контракту.pdf';
      }
      return '/';
    },
    getCancelAgeementFile() {
      if (this.application.application_type) {
        if ([1, 2, 8].includes(this.application.application_type.id)) {
          return '/files/app/БС/Отзыв_согласия_на_зачисление_в_рамках_КЦП.pdf';
        } else if ([3, 4, 7].includes(this.application.application_type.id)) {
          return '/files/app/МАГ/Отзыв_согласия_на_зачисление_в_рамках_КЦП.pdf';
        } else if ([5, 6].includes(this.application.application_type.id)) {
          return '/files/app/АСП/Отзыв_согласия_на_зачисление_в_рамках_КЦП.pdf';
        } else if ([9].includes(this.application.application_type.id)) {
          return '/files/app/СПО/Отзыв_согласия_на_зачисление_в_рамках_КЦП.pdf';
        }
      }
      return '/';
    },
    getCancelContractAgeementFile() {
      if (this.application.contract_type_id && this.application.application_type) {
        if ([1, 2, 8].includes(this.application.application_type.id)) {
          return '/files/app/БС/Отзыв_согласия_на_зачисление_по_контракту.pdf';
        } else if ([3, 4, 7].includes(this.application.application_type.id)) {
          return '/files/app/МАГ/Отзыв_согласия_на_зачисление_по_контракту.pdf';
        } else if ([5, 6].includes(this.application.application_type.id)) {
          return '/files/app/АСП/Отзыв_согласия_на_зачисление_по_контракту.pdf';
        } else if ([9].includes(this.application.application_type.id)) {
          return '/files/app/СПО/Отзыв_согласия_на_зачисление_по_контракту.pdf';
        }
      }
      return '/';
    },
    getCancelFiles() {
      if (this.application.application_type) {
        return '/files/app/Отзыв_поданных_документов.pdf';
      }
      return '/';
    },
  }
}
</script>
